// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const CircleCiIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.74 9.62A2.4 2.4 0 0 0 9.34 12a2.39 2.39 0 0 0 4.8 0 2.4 2.4 0 0 0-2.4-2.38M2 9.52A10.04 10.04 0 0 1 11.74 2C17.3 2 21.8 6.48 21.8 12s-4.5 10-10.05 10A10.05 10.05 0 0 1 2 14.38c0-.26.21-.48.48-.48h4.05c.2 0 .36.12.44.28A5.27 5.27 0 0 0 17 12 5.27 5.27 0 0 0 6.96 9.82a.5.5 0 0 1-.44.28H2.47a.5.5 0 0 1-.48-.48z"
      clipRule="evenodd"
    />
  </svg>,
  "CircleCi",
);
export default CircleCiIcon;
